export enum InvestigationType {
  PANEL = 'Panel',

  LABTESTITEM = 'LabTestItem',

  RADIOLOGY = 'Radiology',
}
